import * as React from 'react';

import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';

import { PageSection } from '../subs/PageSection';
import { WorkshopAdminTable } from '../subs/WorkshopAdminTable';
import { Page } from '../subs/Page';
import { httpGet } from '../Web';
import { ButtonLink } from '../subs/ButtonLink';

import AddIcon from '@mui/icons-material/Add';
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode';

import { useLocation } from 'react-router';
import { getUserAdminWorkshops, isGlobalAdmin } from '../types/User';
import { UserContext } from '../UserProvider';
import { Workshop } from '../types/Workshop';

import { AlertProps } from '@mui/material/Alert';
import { useSnackbar } from '../../contexts/SnackBarContext';

export const Administration = () => {
    const { showSnackbar } = useSnackbar();
    const userContext = React.useContext(UserContext);

    const [workshops, setWorkshops] = React.useState<Workshop[]>([]);
    const [globalAdmin, setGlobalAdmin] = React.useState<boolean>(false);
    const pageLocation = useLocation();

    const showUserFeedback = React.useCallback((msg: string | null, severity: AlertProps['severity'] = 'error') => {
        msg && showSnackbar(msg, severity);
    }, [showSnackbar]);

    // after 60 secs of idle (or not recording new results) refresh the results
    React.useEffect(() => {
        console.log(`initializing user account check`);
        const interval = setInterval(() => {
            httpGet('/api/account/checkloginstatus', new AbortController());
        }, 60000);

        return () => {
            console.log(`clearing user account check Timer`);
            clearInterval(interval);
        };
    }, []);

    React.useEffect(()=> {
        let abortController = new AbortController();

        fetch();

        async function fetch() {
            try {
                let response = await httpGet("api/workshop", abortController);
                const globalAdminFlag = await isGlobalAdmin(userContext.user.id!!, new AbortController());

                setGlobalAdmin(globalAdminFlag);

                if(response?.errorCode) {
                    setWorkshops([]);
                    showUserFeedback(response);
                }
                else {
                    if(!globalAdminFlag) {
                        const userAdminWorkshopsResponse = await getUserAdminWorkshops(userContext.user.id!!, new AbortController());

                        if(!userAdminWorkshopsResponse.failed) {
                            setWorkshops(response?.result.filter((ws: Workshop) => userAdminWorkshopsResponse.result.find(wu => wu.workshopId === ws.id)));
                        }
                        else
                            showUserFeedback(userAdminWorkshopsResponse.errorText);
                            
                    } 
                    else
                        setWorkshops(response?.result);
                }

            } catch(error) {
                showUserFeedback(String(error));
            }

            return function cleanup() {
                abortController.abort();
            }
        }

    }, [showUserFeedback, userContext]);

    const adminFunctions = globalAdmin ?
        <Grid size={2}>
            <ButtonLink fullWidth to={`/DBFunctionPage`} startIcon={<DeveloperModeIcon />}>Additional Administration</ButtonLink>
        </Grid> : <></>

    return <Page heading={"Administration"}>
        <PageSection>
            {[<>
                <Typography variant={'h4'}>
                    {"Workshop specific Administration"}
                </Typography>
                <Typography>
                    {"Below is a list of Workshops which you are assigned as Administrator."}
                </Typography>
            </>]}
        </PageSection>
        
        <Grid container spacing={2}>
            <Grid size={2}>
                <ButtonLink fullWidth to='/WorkshopSettingsModal/new' startIcon={<AddIcon />} state={{ background: pageLocation }} disabled={!globalAdmin}>
                    <Typography>{"Create new Workshop"}</Typography>
                </ButtonLink>
            </Grid>
            <Grid size={8}/>
            {adminFunctions}
        </Grid>

        {[<WorkshopAdminTable rows={workshops.map(({ id, guid, name, location, contactEmail, startDate, endDate, status, paymentType, maxUsers, informationUrl, fee }) =>
        { return { id: id, guid: guid, location, workshop: name, member: "member name lorem ipsum", contactEmail, startDate, endDate, status, paymentType, maxUsers, informationUrl: informationUrl ?? "", fee } })}
        />]}

    </Page>
}